import { __spreadValues } from './chunk-XEH7ODH4.mjs';

// src/defineConfig.ts
var DYNAMIC_ABBY_CONFIG_KEYS = [
  "projectId",
  "currentEnvironment",
  "debug",
  "apiUrl",
  "__experimentalCdnUrl"
];
function defineConfig(dynamicConfig, config) {
  return __spreadValues(__spreadValues({}, dynamicConfig), config);
}

export { DYNAMIC_ABBY_CONFIG_KEYS, defineConfig };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-VRPVF57Z.mjs.map